import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col, NavItem, Table } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import { confirmAlert } from 'react-confirm-alert';
import BundleDetailsPopOver from './bundleDetailsPopOver';
import PreChippingPopOver from "./preChippingPopOver";
import PostChippingPopOver from "./postChippingPopOver";
import './chippingOperation.css';
import { useState } from "react";
import DatePicker from "react-datepicker";
import * as React from 'react';
import { ConfirmPopover } from '../../../preregcamps/confirmPopover/confirmPopover';
import { PROD, PIT_ROLES } from "../../../common/constants";
// import { confirmAlert } from 'react-confirm-alert';

import { authKey, GENERATE_CHIPPING_ORDER, GET_STAKEHOLDER_CATEGORY, CB_CATEGORY_WEIGHT_RATIO_CALCULATION, CHIPPING_ORDER_BY_NUMBER, GET_CHIPPING_QUANTITY, UPDATE_CHIPPING_LOCATION, GET_UNRESTRICTED_INVENTORY, COMPLETE_CHIPPING_OPERATION, GET_URN_LIST } from '../../../common/URLs';
import { useEffect } from "react";
import moment from 'moment';
import Moment from 'moment';
import jwt from 'jwt-decode';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { useLocation } from 'react-router-dom';
import { ContactlessOutlined, SetMealSharp } from "@mui/icons-material";
import { Container, DialogContent, Box, Dialog, DialogActions, Button, Card, CardContent, Grid, FormControl, InputLabel, Select, MenuItem, TextField, Checkbox } from '@mui/material';
import { red } from "@mui/material/colors";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { toast } from 'react-toastify';
import { Fab, Typography } from '@mui/material';
import { KeyboardArrowLeftRounded } from '@mui/icons-material';
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import apiClient from "../../../axios";

function PlantChippingOperation() {

    const navigate = useNavigate();
    const decoded = jwt(getLocalStorageItem('id_token'));
    const location = useLocation();
    const [chippingList, setChippingList] = useState();
    const [chippingdate, setChippingdate] = useState(null);
    const [stakeholderDetails, setStakeholderDetails] = useState();
    const [chippingOrder, setChippingOrder] = React.useState({});
    const [chippingQuantity, setChippingQuantity] = React.useState(0);
    const [quantityForChipping, setQuantityForChipping] = useState(0);
    const [weeklyScheduleNumber, setWeeklyScheduleNumber] = useState();
    const [scheduleLineNumber, setScheduleLineNumber] = useState();
    const [unrestrictInventory, setUnrestrictInventory] = useState({});
    const [rbInventories, setRbInventories] = useState([]);
    const [hideChippingData, setHideChippingData] = useState(true);
    const [enableGenerateOrder, setEnableGenerateOrder] = useState(false);
    const [showGridOnGeneration, setShowGridOnGeneration] = useState(false);
    const [addChippingOrder, setAddChippingOrder] = useState();
    const [selectedBundles, setSelectedBundles] = useState([]);
    const [selectedChippedBundles, setSelectedChippedBundles] = useState([]);
    const [postChipdata, setPostChipdata] = useState({});
    const [hideLink, setHideLink] = useState(false);
    const [heapNumber, setHeapNumber] = useState("");
    const [chippingOrderDetails, setChippingOrderDetails] = useState([]);
    const [newHeaps, setNewHeaps] = useState([]);
    const [oldHeaps, setOldHeaps] = useState([]);
    const [heapGenerated, setHeapGenerated] = useState(false);
    const details = location?.state?.selectedRow;
    // console.log("details", details)
    const [readOnly, setReadOnly] = useState(false);
    const [orderGenerated, setOrderGenerated] = useState(false);
    const [partialChippingDone, setPartialChippingDone] = useState(false)
    const [skippedBundles, setSkippedBundles] = useState([]);
    const [totalPreChippingWeight, setTotalPreChippingWeight] = useState(0);
    const [locationUpdated, setLocationUpdated] = useState(false);
    const [error, setError] = useState("");
    const [logModalOpen, setLogModalOpen] = useState(false);
    const [cofirmMessage, setConfirmMessage] = useState("");
    const [noBundleError, setNoBundleError] = useState("");
    const [selectedUrn, setSelectedUrn] = useState();
    const [urnList, setUrnList] = useState([]);
    const [scheduleChippingDate, setScheduleChippingDate] = useState();
    const [qtyError, setQtyError] = useState('');

    const [logModalOpen4, setLogModalOpen4] = useState(false);
    const handleLogModalOpen4 = () => setLogModalOpen4(true);
    const handleLogModalClose4 = () => setLogModalOpen4(false);

    const [confirmOpen, setConfirmOpen] = useState(false);
    const handleConfirmOpen = () => setConfirmOpen(true);
    const handleConfirmClose = () => setConfirmOpen(false);

    const [confirmOpen2, setConfirmOpen2] = useState(false);
    const handleConfirmOpen2 = () => setConfirmOpen2(true);
    const handleConfirmClose2 = () => setConfirmOpen2(false);

    const [confirmOpen3, setConfirmOpen3] = useState(false);
    const handleConfirmOpen3 = () => setConfirmOpen3(true);
    const handleConfirmClose3 = () => setConfirmOpen3(false);


    useEffect(() => {
        console.log("checking Details = ", details)
        if (details?.chippingStatus === "ChippingCompleted" || details?.chippingStatus === "HeapGenerated" || details?.chippingStatus === "PartialChippingDone") {
            setShowGridOnGeneration(true);
            setAddChippingOrder(details);
            setChippingdate(moment(details.chippingOrderDate).format("YYYY-MM-DD"));
            setHideLink(true);
            setQuantityForChipping(details.chippingQuantity);
            setReadOnly(true)
            //getUnrestrictedInventory();
            getChippingDetails(details);
            setHeapGenerated(true);
            setOrderGenerated(true);
            if (details?.chippingStatus === "PartialChippingDone") {
                setPartialChippingDone(true)
            }

        } else if (details?.chippingStatus === "ChippingLocationUpdated" || details?.chippingStatus === "CompleteChippingDone") {
            setShowGridOnGeneration(true);
            setAddChippingOrder(details);
            setChippingdate(moment(details.chippingOrderDate).format("YYYY-MM-DD"))
            setHideLink(true);
            setQuantityForChipping(details.chippingQuantity);
            setReadOnly(true)
            //getUnrestrictedInventory();
            getChippingDetails(details);
            setHeapGenerated(true);
            setLocationUpdated(true);
            setOrderGenerated(true);

        } else if (details?.chippingStatus === "InProgress") {
            //"InProgress"
            setShowGridOnGeneration(true);
            setAddChippingOrder(details);
            setChippingdate(moment(details.chippingOrderDate).format("YYYY-MM-DD"))
            setHideLink(true);
            setQuantityForChipping(details.chippingQuantity);
            //setReadOnly(true)
            getUnrestrictedInventory();
            getChippingDetails(details);
            setOrderGenerated(true)
            //updatePostChippingData()
            //setHeapGenerated(true);
            //setLocationUpdated(true);

        } else {
            setChippingdate(null)
            getChippingQuantity();
            getUnrestrictedInventory();
        }

    }, [details]);

    // console.log('addChippingOrder ---> ', addChippingOrder)
    // console.log("showGrid", showGridOnGeneration)

    // useEffect(() => {
    //     getUrnList();
    // }, []);

    // function getUrnList() {
    //     loaderService.showLoader()
    //     apiClient
    //         .post(GET_URN_LIST,
    //             {
    //                 "stakeholderType": "LLE"
    //             },
    //             {
    //                 headers: {
    //                     Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
    //                 }
    //             }, null
    //         )
    //         .then((response) => {
    //             setUrnList(response.data.urnNoList);
    //             setSelectedUrn(response?.data?.urnNoList[0]);
    //             getUnrestrictedInventory(null, response.data.urnNoList[0]);
    //             getChippingQuantity(null, response.data.urnNoList[0]);
    //             loaderService.hideLoader();
    //         })
    //         .catch(function (error) {
    //             console.log(error);
    //             loaderService.hideLoader();
    //             toast.error(error.message);
    //         });
    // }


    // useEffect(() => {
    //     if (decoded.extension_URN) {
    //         getStakeDetails();
    //     }
    // }, [decoded.extension_URN]);


    // function getStakeDetails() {
    //     loaderService.showLoader()
    //     apiClient
    //         .post(GET_STAKEHOLDER_CATEGORY,
    //             {
    //                 "urn": decoded.extension_URN,
    //                 "type": ""
    //             },
    //             {
    //                 headers: {
    //                     Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
    //                 }
    //             }, null
    //         )
    //         .then((response) => {
    //             setStakeholderDetails(response.data);
    //             loaderService.hideLoader()
    //         })
    //         .catch(function (error) {
    //             console.log(error);
    //             loaderService.hideLoader()
    //             toast.error(error.message);
    //         });
    // }

    // useEffect(() => {
    //     if(stakeholderDetails){
    //         getUnrestrictedInventory();
    //     }  
    // }, []);


    const getChippingDetails = (details) => {
        // console.log("getChip", details)
        let data = {
            "stakeholderUrn": "ABEPL",
            "chippingOrderNo": details.chippingOrderNo
        };
        let headers = {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }

        apiClient
            .post(CHIPPING_ORDER_BY_NUMBER, data, { headers })
            .then(res => {
                let oldHeaps = res.data.chippingOrderList.filter(chip => chip.status === "PartialChippingDone")
                let newHeaps = res.data.chippingOrderList.filter(chip => chip.status != "PartialChippingDone")
                setNewHeaps(newHeaps);
                setOldHeaps(oldHeaps);
                setChippingOrderDetails(res.data.chippingOrderList);
                setAddChippingOrder(res.data.chippingOrderList[0]);
                res.data.rbInventories.forEach(inv => {
                    inv.inventoryId = inv.id;
                })

                if (details?.chippingStatus === "InProgress") {
                    res.data?.chippingOrderList?.forEach((order) => {
                        if (order.category === "Un-Restricted") {
                            postChipdata.postChippingUnrestrictedMoisture = order?.postChippingMoisture
                            postChipdata.postChippingUnrestrictedWeight = order?.postChippingWeight
                        }
                        // if (order.category === "Restricted") {
                        //     postChipdata.postChippingRestrictedMoisture = order?.postChippingMoisture
                        //     postChipdata.postChippingRestrictedWeight = order?.postChippingWeight
                        // }
                        if (order.category === "Scrap") {
                            postChipdata.postChippingScrapMoisture = order?.postChippingMoisture
                            postChipdata.postChippingScrapWeight = order?.postChippingWeight
                        }
                    })
                }
                setPostChipdata(postChipdata);
                res.data.rbInventories.sort((a, b) => {
                    if (new Date(a.consignmentDeliveryTimestamp) < new Date(b.consignmentDeliveryTimestamp)) {
                        return 1;
                    } else {
                        return -1;
                    }
                })
                setSelectedBundles(res.data.rbInventories);

            })
    }
    const setInventories = (inventories) => {
        //all selected bundles 
        let totalWeight = inventories.reduce((total, bundle) =>
            total = total + (bundle.checkVal ? Number(bundle.arrivalWeight) : 0)
            , 0)
        if (totalWeight >= quantityForChipping) {
            setEnableGenerateOrder(true);
            setChippingQuantity(totalWeight);
        } else {
            toast.error("Selected Bundle quantity should be greater than or equal to chipping quantity")
            setEnableGenerateOrder(false);
        }

        setRbInventories([...inventories]);
        let lastBundleChecked = false;
        inventories.forEach((inv, index) => {
            if (inv.checkVal) {
                inv.isSelected = true;
                inv.comment = null;
                if (index === inventories.length - 1) {
                    setEnableGenerateOrder(true);
                    setChippingQuantity(totalWeight);
                }
            }
        });
        setSkippedBundles(inventories.filter(bundle => ((!bundle?.checkVal) && bundle?.comment != null && bundle?.comment != "")));
        setSelectedBundles(inventories.filter(bundle => bundle.checkVal));

        //checkVal will be true for selected inventory 
    }

    const clearDate = (e) => {
        setChippingdate(null)
        clearDateSearch();
    }

    const clearDateSearch = (date, urn) => {
        // setEnableGenerateOrder(false);
        // setShowGridOnGeneration(false);
        setRbInventories([]);
        let dateVal = moment(date).format("YYYY-MM-DD");
        let data = {
            "stakeholderUrn": decoded.extension_URN ? decoded.extension_URN : details?.stakeholderUrn ? details?.stakeholderUrn : urn ? urn : selectedUrn ? selectedUrn : '',
            "date": null,
        };
        let headers = {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }

        apiClient
            .post(GET_CHIPPING_QUANTITY, data, { headers })
            .then(res => {
                setChippingList(res.data.chippingQuantityListVM)
                // setQuantityForChipping(res.data.quantityForChipping);
                //setQuantityForChipping(60);
                let quantityForChippingVal = res.data.quantityForChipping;
                setWeeklyScheduleNumber(res.data.weeklyScheduleNumber);
                setScheduleLineNumber(res.data.scheduleLineNumber);
                // getUnrestrictedInventory(quantityForChippingVal);

            })
    }

    const getChippingQuantity = (date, urn) => {
        // setEnableGenerateOrder(false);
        // setShowGridOnGeneration(false);
        setRbInventories([]);
        let dateVal = moment(date).format("YYYY-MM-DD");
        let data = {
            "stakeholderUrn": 'ABEPL',
            "date": date ? date : chippingdate ? chippingdate : null,
        };
        let headers = {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }

        apiClient
            .post(GET_CHIPPING_QUANTITY, data, { headers })
            .then(res => {
                setChippingList(res.data.chippingQuantityListVM)
                // setQuantityForChipping(res.data.quantityForChipping);
                //setQuantityForChipping(60);
                let quantityForChippingVal = res.data.quantityForChipping;
                setWeeklyScheduleNumber(res.data.weeklyScheduleNumber);
                setScheduleLineNumber(res.data.scheduleLineNumber);
                getUnrestrictedInventory(quantityForChippingVal);

            })
    }

    const getUnrestrictedInventory = (quantityForChippingVal, urn) => {
        // const selectedUrn = e.target.value
        // console.log("quantityForChippingVal",quantityForChippingVal)
        let data = {
            "stakeHolderUrn": "ABEPL",
            "stakeHolderType": "Plant"

        };
        let headers = {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }

        apiClient
            .post(GET_UNRESTRICTED_INVENTORY, data, { headers })
            .then(res => {
                setUnrestrictInventory(res.data.inventoryMovementSum);
                res.data?.inventoryMovementSum?.rbInventories.sort((a, b) => {
                    if (new Date(a.consignmentDeliveryTimestamp) < new Date(b.consignmentDeliveryTimestamp)) {
                        return -1;
                    } else {
                        return 1;
                    }
                })

                let chippingQuantityVal = quantityForChippingVal;
                //console.log("chippingQuantityVal", chippingQuantityVal)
                let totalWeightAdded = 0;
                let breakLoop = false;
                if (chippingQuantityVal) {
                    res?.data?.inventoryMovementSum?.rbInventories.forEach(inv => {
                        totalWeightAdded = totalWeightAdded + inv.arrivalWeight;
                        if (!breakLoop) {
                            if (totalWeightAdded >= chippingQuantityVal) {

                                breakLoop = true;
                                inv.checkVal = true;
                            } else {
                                inv.checkVal = true;
                            }
                        }
                    })
                }


                res?.data?.inventoryMovementSum?.rbInventories && setRbInventories(res?.data?.inventoryMovementSum?.rbInventories)
            })
    }

    const onConfirmSave = (e) => {
        handleConfirmClose();
        getSaveChipping(false);
    }

    const onSaveButtonClick = (e) => {
        handleConfirmOpen();
    }

    const onConfirmGenerateHeap = (e) => {
        handleConfirmClose2();
        getSaveChipping(true);
    }

    const onGenerateHeapButtonClick = (e) => {
        handleConfirmOpen2();
    }


    const getSaveChipping = (isChippingCompleted) => {
        let totalHeapWeight = Number(postChipdata.postChippingUnRestrictedWeight) + Number(postChipdata.postChippingRestrictedWeight) +
            Number(postChipdata.postChippingScrapWeight)
        // if (!(totalHeapWeight <= totalPreChippingWeight)) {
        //     setError("Total Heap Weight cannot be more than chipping weight");
        //     return;
        // } else {
        //     setError("");
        // }
        let selectedBundlesData = [...selectedBundles];
        selectedBundlesData.forEach(b => {
            selectedChippedBundles.forEach(b1 => {
                if (b1.bundleId === b.bundleId) {
                    b.isBundleSelected = true;
                }
            })
            if (!b.isBundleSelected) {
                b.isBundleSelected = false;
            }
        })

        let data = {
            "chippingScheduleId": addChippingOrder.id,
            "IsNewChippingSet": partialChippingDone ? true : false,
            ...addChippingOrder,
            ...postChipdata,
            "isChippingCompleted": isChippingCompleted ? isChippingCompleted : false,
            "IsHeapGenerate": isChippingCompleted ? isChippingCompleted : false,
            "preChippingDetails": [
                ...selectedBundlesData
            ]
        }
        let headers = {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }

        apiClient
            .post(COMPLETE_CHIPPING_OPERATION, data, { headers })
            .then(res => {
                if (isChippingCompleted) {
                    //setChippingOrderDetails(res.data.chippingOrderDetailsList);
                    getChippingDetails({ chippingOrderNo: res.data?.chippingOrderDetailsList[0]?.chippingOrderNo })
                    setHeapGenerated(true)
                    setLocationUpdated(false);
                    setPartialChippingDone(false);

                }
                // confirmAlert({
                //     customUI: ({ onClose }) => {
                //         return (
                //             isChippingCompleted ? <ConfirmPopover hideLink={true} onClose={onClose} title={"Chipping Completed Successfully"} /> : <ConfirmPopover hideLink={true} onClose={onClose} title={"Chipping Details Saved Successfully"} />
                //         );
                //     }
                // });
                if (isChippingCompleted) {
                    // setLogModalOpen(true);
                    // setConfirmMessage("Chipping Completed Successfully")
                    toast.success("Chipping Completed Successfully")
                } else {
                    // setLogModalOpen(true);
                    // setConfirmMessage("Chipping Details Saved Successfully")
                    toast.success("Chipping Details Saved Successfully")
                }
            })
    }

    function formatDate(date = new Date()) {
        const year = date.toLocaleString('default', { year: 'numeric' });
        const month = date.toLocaleString('default', {
            month: '2-digit',
        });
        const day = date.toLocaleString('default', { day: '2-digit' });

        return [year, month, day].join('-');
    }

    const generateChippingOrder = () => {
        selectedBundles.forEach(bundle => {
            bundle.inventoryId = bundle.id
        })
        loaderService.showLoader()
        apiClient
            .post(GENERATE_CHIPPING_ORDER,
                {
                    "id": selectedRow,
                    "weeklyScheduleNumber": weeklyScheduleNumber,
                    "scheduleLineNumber": scheduleLineNumber,
                    "stakeholderType": "Plant",
                    "stakeholderUrn": "ABEPL",
                    "scheduleDate": scheduleChippingDate,
                    "chippingQuantity": chippingQuantity,
                    "chippingOrderDate": formatDate(new Date()),
                    "chippingOrderInventories": [...selectedBundles, ...skippedBundles]

                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setAddChippingOrder(response.data.chippingOrderDetails);
                setShowGridOnGeneration(true);
                setHideLink(true)
                loaderService.hideLoader();
                setEnableGenerateOrder(false);
                setOrderGenerated(true)
                //getChippingQuantity(chippingdate);
                getUnrestrictedInventory();
            })
            .catch(function (error) {
                setAddChippingOrder(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const onClickBundle = (onClose) => {
        // confirmAlert({
        //     customUI: ({ onClose }) => {
        //         return (
        //             <BundleDetailsPopOver inventories={setInventories} rbInventories={rbInventories} onClose={onClose} />
        //         );
        //     }
        // });
        handleLogModalOpen4(onClose);
    }

    const editChippingDetails = (bundle) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <PreChippingPopOver updateBundleData={updateBundleData} bundle={bundle} onClose={onClose} />
                );
            }
        });
    }
    const updateBundleData = (bundle) => {
        let selectedBundlesData = [...selectedBundles];
        selectedBundlesData.forEach(bundleData => {
            if (bundle.bundleId === bundleData.bundleId) {
                bundleData.preChippingMoisture = Number(bundle.preChippingMoisture);
                bundleData.preChippingWeight = Number(bundle.preChippingWeight);
                setTotalPreChippingWeight(totalPreChippingWeight + Number(bundle.preChippingWeight));
            }
        })
        setSelectedBundles(selectedBundlesData)
    }
    const editPostChippingDetails = (data, type) => {
        let values = {}
        if (type != "HeapLoction") {
            if (type === "Un-Restricted") {
                values.moisture = data?.postChippingUnrestrictedMoisture
                values.weight = data?.postChippingUnrestrictedWeight
            }
            // if (type === "Restricted") {
            //     values.moisture = data?.postChippingRestrictedMoisture
            //     values.weight = data?.postChippingRestrictedWeight
            // }
            if (type === "Scrap") {
                values.moisture = data?.postChippingScrapMoisture
                values.weight = data?.postChippingScrapWeight
            }
        } else {
            values.location = data?.location;
        }
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <PostChippingPopOver values={values} updatedValues={updatedValues} data={data} type={type} onClose={onClose} />
                );
            }
        });
    }

    const handleChange = (e, postChip) => {
        let chippingOrderDetailsTemp = [...chippingOrderDetails];
        chippingOrderDetailsTemp.forEach(chipDetails => {
            if (chipDetails.id === postChip.id) {
                chipDetails.location = e.target.value;
            }
        })
        setChippingOrderDetails(chippingOrderDetailsTemp);
    }

    const onConfirmComplete = (e) => {
        handleConfirmClose3();
        heapLocationUpdate(true);
    }

    const onCompleteButtonClick = (e) => {
        handleConfirmOpen3();
    }



    const heapLocationUpdate = (IsCompleteChippingDoneVal) => {


        let data = {
            "chippingOrderNo": chippingOrderDetails[0].chippingOrderNo,
            IsCompleteChippingDone: IsCompleteChippingDoneVal,
            "heapLocationList": [
                ...chippingOrderDetails
            ],
            "roleName": decoded.extension_URN ? 'stakeholder' : localStorage.getItem('role'),
            "userName": localStorage.getItem('userName'),
        }
        let headers = {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }

        apiClient
            .post(UPDATE_CHIPPING_LOCATION, data, { headers })
            .then(res => {
                setLocationUpdated(true);
                setPartialChippingDone(!IsCompleteChippingDoneVal ? true : false)
                if (!IsCompleteChippingDoneVal) {
                    setPostChipdata({});
                }
                // confirmAlert({
                //     customUI: ({ onClose }) => {
                //         return (
                //             <ConfirmPopover hideLink={true} onClose={onClose} title={"Chipping Location Updated"} />
                //         );
                //     }
                // });
                // setLogModalOpen(true);
                // setConfirmMessage("Chipping Location Updated")
                toast.success("Chipping Location Updated")
            })
    }

    const updatedValues = (updateData) => {
        setPostChipdata({ ...updateData });
        let chippingOrderDetailsTemp = [...chippingOrderDetails]
        chippingOrderDetailsTemp.forEach(e => {
            if (e.category === updateData.category) {
                e.location = updateData.location;
            }
        }

        )
        setChippingOrderDetails([...chippingOrderDetailsTemp]);

    }
    // const chippingDate = (date) => {
    //     setChippingdate(date)
    //     getChippingQuantity(date)
    // }
    const onGenerateOrder = (e) => {
        if (quantityForChipping > 0) {
            generateChippingOrder();
            setQtyError("");
        }
        else {
            setQtyError("Chipping Quantity should be more than zero! Please select proper date");
        }
    }

    const checkVal = (bundle) => {

        // bundle.chippedSelected = bundle.chippedSelected ? false : true;
        let selectedBundlesList = [...selectedBundles];
        selectedBundlesList.forEach(b => {
            if (bundle.bundleId === b.bundleId) {
                b.chippedSelected = b.chippedSelected ? false : true;
            }
        })

        setSelectedBundles([...selectedBundles]);
        if (bundle.chippedSelected) {
            setSelectedChippedBundles([...selectedChippedBundles, bundle])
        } else {
            setSelectedChippedBundles([...selectedChippedBundles.filter(b => b.bundleId != bundle.bundleId)])
        }

    }

    const calculateCbWeight = () => {
        let data = {
            "cBInventories": [...selectedChippedBundles]
        };
        let headers = {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
        let noBundleSelected = true;
        selectedBundles.forEach(bundle => {
            if (bundle.chippedSelected) {
                noBundleSelected = false;
            }
        })
        if (noBundleSelected) {
            setNoBundleError("Please select atleast one Bundle")
            return;
        } else {
            setNoBundleError("")
        }


        apiClient
            .post(CB_CATEGORY_WEIGHT_RATIO_CALCULATION, data, { headers })
            .then(res => {
                let postChipdata = {}

                res.data?.cbCategoryWeightCalculationList?.forEach((order) => {
                    if (order.categoryType === "Unrestricted") {
                        postChipdata.postChippingUnrestrictedMoisture = order?.averageMoisture
                        postChipdata.postChippingUnrestrictedWeight = order?.totalWeight
                    }
                    // if (order.categoryType === "Restricted") {
                    //     postChipdata.postChippingRestrictedMoisture = order?.averageMoisture
                    //     postChipdata.postChippingRestrictedWeight =order?.totalWeight
                    // }
                    if (order.categoryType === "Scrap") {
                        postChipdata.postChippingScrapMoisture = order?.averageMoisture
                        postChipdata.postChippingScrapWeight = order?.totalWeight
                    }
                })
                setPostChipdata(postChipdata);
            })
    }
    const onValueUrn = (e) => {
        // console.log("value",e.target.value)
        // console.log("pickUpdate",pickUpdate)
        setSelectedUrn(e.target.value);
        getUnrestrictedInventory(null, e.target.value);
        getChippingQuantity(chippingdate, e.target.value);
        // getconsignmentDetails(pickUpdate,e.target.value)
    }

    const handleDateChange = (e) => {
        setChippingdate(e.format("YYYY-MM-DD"));
        getChippingQuantity(e.format("YYYY-MM-DD"), selectedUrn);
        setQtyError('');
    }

    const [selectedRow, setSelectedRow] = useState(null);

    const handleCheckboxChange = (id) => {
        setSelectedRow((prevSelectedRow) => {
            const newRowSelected = prevSelectedRow === id ? null : id;
            let qty = 0;
            let weeklyScheduleNumber = ''
            let scheduleLineNumber = ''
            let scheduleChippingDate = ''
            if (newRowSelected !== null) {
                chippingList.forEach((item) => {
                    if (newRowSelected === item.id) {
                        qty = item.quantityForChipping;
                        weeklyScheduleNumber = item.weeklyScheduleNumber;
                        scheduleLineNumber = item.scheduleLineNumber;
                        scheduleChippingDate = item.schedulePickupDate
                    }
                });
            }
            setQuantityForChipping(qty);
            setWeeklyScheduleNumber(weeklyScheduleNumber);
            setScheduleLineNumber(scheduleLineNumber);
            setScheduleChippingDate(scheduleChippingDate);
            return newRowSelected;
        });
    };


    const chippingCol = [
        {
            field: 'checkbox',
            headerName: 'Select',
            renderCell: (params) => (
                <Checkbox
                    checked={params.row.id === selectedRow}
                    onChange={() => handleCheckboxChange(params.row.id)}
                />
            ),
            width: 80,
        },
        { field: 'weeklyScheduleNumber', headerName: 'Schedule Number', width: 200 },
        {
            field: 'scheduleLineNumber', headerName: 'Schedule Line Number', width: 150,
        },
        {
            field: 'schedulePickupDate', headerName: 'Schedule Pickup Date', width: 150,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
        },
        {
            field: 'scheduleRbCbQuantity', headerName: 'Quantity', width: 150,
        },

    ];

    const columns: GridColDef[] = [

        {
            field: 'rowSelect', headerName: '', width: 80, hide: heapGenerated,
            renderCell: (params) => {
                return (
                    <>
                        <Checkbox name="rowSelect" value={params.row.chippedSelected} checked={params.row.chippedSelected} onChange={() => checkVal(params.row)} />
                    </>
                )
            }

        },
        { field: 'bundleId', headerName: 'Bundle ID# (For pickup from RB stack)', width: 320 },
        {
            field: 'arrivalMoisture',
            headerName: 'Moisture',
            width: 100,

        },
        {
            field: 'arrivalWeight',
            headerName: 'Weight',
            width: 130,
        },
        {
            field: 'preChippingMoisture',
            headerName: 'Moisture',
            width: 100,
            valueGetter: (params) => {
                return params.row.preChippingMoisture ? params.row.preChippingMoisture : params.row.reductionMoisture;
            }
        },
        {
            field: 'preChippingWeight',
            headerName: 'Weight',
            width: 130,
            valueGetter: (params) => {
                return params.row.preChippingWeight ? params.row.preChippingWeight : params.row.reductionWeight;
            }
        },
        {
            field: 'action', headerName: '', width: 250,
            renderCell: (params) => {
                return (
                    <>
                        {!heapGenerated && (!localStorage.getItem('role') == PIT_ROLES.ProcessingIncharge) &&
                            <Button variant="contained" onClick={(e) => editChippingDetails(params.row)} >Edit</Button>
                        }
                    </>
                )
            }

        }

    ];

    const columnGroupingModel: GridColumnGroupingModel = [
        {
            groupId: 'During GRN',
            children: [{ field: 'arrivalMoisture' }, { field: 'arrivalWeight' }],
        },
        {
            groupId: 'Pre-Chipping',
            children: [{ field: 'preChippingMoisture' }, { field: 'preChippingWeight' }],
        },
    ];


    const col = [

        {
            field: 'inventory',
            headerName: '',
            width: 250,
        },
        {
            field: 'moisture',
            headerName: 'Moisture',
            width: 150,
        },
        {
            field: 'weight',
            headerName: 'Weight',
            width: 150,
        },
        {
            field: 'edit',
            headerName: '',
            width: 150,
            renderCell: (params) => {
                return (
                    <>
                        {!readOnly && (!localStorage.getItem('role') == PIT_ROLES.ProcessingIncharge) && <Button variant="contained" onClick={(e) => editPostChippingDetails(postChipdata, "Un-Restricted")} >Edit</Button>}
                    </>
                )
            }
        }
    ];

    const rows = [
        {
            id: 1,
            inventory: 'Un-Restricted Inventory',
            moisture: postChipdata?.postChippingUnrestrictedMoisture,
            weight: postChipdata?.postChippingUnrestrictedWeight,
            edit: (!readOnly && (!localStorage.getItem('role') == PIT_ROLES.ProcessingIncharge) && <Button variant="contained" onClick={(e) => editPostChippingDetails(postChipdata, "Un-Restricted")} >Edit</Button>)
        },
        {
            id: 2,
            inventory: 'Dust Inventory',
            moisture: postChipdata?.postChippingScrapMoisture,
            weight: postChipdata?.postChippingScrapWeight,
            edit: (!readOnly && (!localStorage.getItem('role') == PIT_ROLES.ProcessingIncharge) && <Button variant="contained" onClick={(e) => editPostChippingDetails(postChipdata, "Scrap")} >Edit</Button>)

        },

    ];
    const oldHeapsCol = [
        {
            field: 'category',
            headerName: '',
            width: 150,
        },
        {
            field: 'postChippingMoisture',
            headerName: 'Moisture',
            width: 150,
        },
        {
            field: 'postChippingWeight',
            headerName: 'Weight',
            width: 150,
        },
        {
            field: 'heapNumber',
            headerName: 'Heap Number',
            width: 150,
        },

        {
            field: 'location',
            headerName: 'Heap Location',
            width: 200,
            renderCell: (params) => {
                return (
                    <FormControl>
                        <Select disabled={locationUpdated || params.row.status === "PartialChippingDone"} onChange={(e) => handleChange(e, params.row)} name="location" value={params.row?.location} >
                            <MenuItem>Select</MenuItem>
                            <MenuItem value={"Bay1"}>{"Bay1"}</MenuItem>
                            <MenuItem value={"Bay2"}>{"Bay2"}</MenuItem>
                        </Select>
                    </FormControl>
                )
            }
        },
    ];

    const newHeapsCol = [
        {
            field: 'category',
            headerName: '',
            width: 200,
            valueGetter: (params) => {
                return params.row?.category === "Scrap" ? "Dust" + " " + 'Inventory' : params.row?.category + " " + 'Inventory'
            }
        },
        {
            field: 'postChippingMoisture',
            headerName: 'Moisture',
            width: 150,
        },
        {
            field: 'postChippingWeight',
            headerName: 'Weight',
            width: 150,
        },
        {
            field: 'heapNumber',
            headerName: 'Heap Number',
            width: 250,
        },

        {
            field: 'location',
            headerName: 'Heap Location',
            width: 150,
            renderCell: (params) => {
                return (
                    <FormControl fullWidth size="small">
                        <Select disabled={locationUpdated || params.row.status === "PartialChippingDone"} onChange={(e) => handleChange(e, params.row)} name="location" value={params.row?.location} >
                            <MenuItem>Select</MenuItem>
                            <MenuItem value={"Bay1"}>{"Bay1"}</MenuItem>
                            <MenuItem value={"Bay2"}>{"Bay2"}</MenuItem>
                        </Select>
                    </FormControl>
                )
            }
        },
    ];

    const partialChippingCol = [

        {
            field: 'inventory',
            headerName: '',
            width: 250,
        },
        {
            field: 'moisture',
            headerName: 'Moisture',
            width: 150,
        },
        {
            field: 'weight',
            headerName: 'Weight',
            width: 150,
        },
        {
            field: 'edit',
            headerName: '',
            width: 150,
        }
    ];

    const partialChippingRow = [
        {
            id: 1,
            inventory: 'Un-Restricted Inventory',
            moisture: postChipdata?.postChippingUnrestrictedMoisture,
            weight: postChipdata?.postChippingUnrestrictedWeight,
            edit:
                <Button variant="contained" onClick={(e) => editPostChippingDetails(postChipdata, "Un-Restricted")} >Edit</Button>
        },
        {
            id: 2,
            inventory: 'Scrap Inventory',
            moisture: postChipdata?.postChippingScrapMoisture,
            weight: postChipdata?.postChippingScrapWeight,
            edit:
                <Button variant="contained" onClick={(e) => editPostChippingDetails(postChipdata, "Scrap")} >Edit</Button>

        },

    ];



    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT11</p>}
                <Typography variant="h4" sx={{ mb: 2 }}>
                    <Fab onClick={() => { navigate(-1) }} size="small" aria-label="back" title='Back'>
                        <KeyboardArrowLeftRounded />
                    </Fab> Chipping Operation
                </Typography>
                <Card>
                    <CardContent>

                        <Grid container spacing={1} direction="row" mt={1}>
                            <Grid item xs={12}>
                                <Grid container spacing={2}>
                                    {/* {localStorage.getItem('role') == PIT_ROLES.PitScmUser && !(location?.state?.selectedRow) ?
                                        <Grid item xs={12} lg={4}>
                                            <FormControl fullWidth size="small">
                                                <InputLabel>Select URN</InputLabel>
                                                <Select label='Select URN' disabled={showGridOnGeneration} value={selectedUrn || ''} onChange={(e) => onValueUrn(e)}>
                                                    {urnList &&
                                                        urnList.map((urns) => (
                                                            <MenuItem value={urns}>{urns}</MenuItem>
                                                        ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        : null} */}
                                    {!orderGenerated &&
                                        <>
                                            <Grid item xs={12} lg={4}>
                                                <FormControl fullWidth>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DesktopDatePicker
                                                            label="Select Date"
                                                            inputFormat="DD/MM/YYYY"
                                                            value={chippingdate}
                                                            // maxDate={Moment().toDate()}
                                                            onChange={(e) => handleDateChange(e)}
                                                            renderInput={(params) => <TextField size="small" {...params} />}
                                                        />
                                                    </LocalizationProvider>
                                                    {/* <FormHelperText sx={{ color: 'red' }}>{errorMessage.dateError}</FormHelperText> */}
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} lg={4}>
                                                <Button variant="contained" onClick={(e) => clearDate(e)}>Clear Date</Button>
                                            </Grid>
                                            <Grid item xs={12} lg={4}></Grid>
                                        </>
                                    }
                                    {/* <Grid item xs={12} lg={4}></Grid> */}
                                    <Grid item xs={12} lg={4}>
                                        <TextField error={qtyError} helperText={qtyError} fullWidth size='small' label='Quantity For Chipping' value={quantityForChipping || 0} type="text" disabled={true} />
                                    </Grid>
                                    {!orderGenerated &&
                                        <>
                                            <Grid item xs={12} lg={4}>
                                                <TextField fullWidth size="small" label='Unrestricted RB Inventory' type="text" value={unrestrictInventory?.unrestrictedRBInventory || ''} disabled={true} />
                                            </Grid>
                                            <Grid item xs={12} lg={4}>
                                                <TextField fullWidth size='small' label='Unrestricted CB Inventory' type="text" value={unrestrictInventory?.unrestrictedCBInventory || ''} disabled={true} />
                                            </Grid>
                                            <Grid item xs={12} lg={4}>
                                                {!hideLink && <Button onClick={onClickBundle} href=" #">Click to see the Bundle Details</Button>}
                                            </Grid>
                                            <Grid item xs={12} lg={12}> {enableGenerateOrder && <Button variant="contained" type='submit' onClick={(e) => onGenerateOrder(e)}>Generate Order No</Button>}
                                            </Grid>
                                        </>
                                    }
                                    {
                                        !orderGenerated && chippingList &&
                                        <Grid item xs={12} lg={12}>
                                            <Box style={{ height: 350, width: '100%' }}>
                                                <DataGrid
                                                    rows={chippingList}
                                                    columns={chippingCol}
                                                    pageSize={10}
                                                    getRowId={(row) => row.id}
                                                    components={{ Toolbar: QuickSearchToolbar }}
                                                />
                                            </Box>
                                        </Grid>

                                    }
                                    {showGridOnGeneration &&
                                        <>
                                            <Grid item xs={12} lg={4}>
                                                <TextField fullWidth size="small" label='Chipping Order Number' type="text" value={addChippingOrder?.chippingOrderNo} placeholder="001" disabled={true} />
                                            </Grid>
                                            <Grid item xs={12} lg={4}>
                                                <FormControl fullWidth>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DesktopDatePicker
                                                            label="Chipping Order Date"
                                                            inputFormat="DD/MM/YYYY"
                                                            value={addChippingOrder?.chippingOrderDate}
                                                            disabled
                                                            renderInput={(params) => <TextField size="small" {...params} />}
                                                        />
                                                    </LocalizationProvider>
                                                </FormControl>
                                            </Grid>
                                        </>
                                    }
                                    {showGridOnGeneration &&
                                        <>
                                            <Grid item xs={12} lg={12}>
                                                <Typography variant="h5" gutterBottom>Raw Bamboo Issue</Typography>

                                                <Box style={{ height: 400, width: '100%' }}>
                                                    {
                                                        selectedBundles &&
                                                        <DataGrid
                                                            experimentalFeatures={{ columnGrouping: true }}
                                                            columnGroupingModel={columnGroupingModel}
                                                            rows={selectedBundles}
                                                            columns={columns}
                                                            pageSize={10}
                                                            getRowId={(row) => row.bundleId}

                                                        />
                                                    }
                                                </Box>
                                                {error != "" && <div className="error-msg">
                                                    {error}
                                                </div>}
                                                {noBundleError != "" && <div style={{ marginLeft: "8px" }} className="error-msg">
                                                    {noBundleError}
                                                </div>}
                                            </Grid>
                                            {!heapGenerated &&
                                                <>
                                                    <Grid item xs={12} lg={12}>
                                                        <Button sx={{ minWidth: 100 }} variant="contained" hidden={localStorage.getItem('role') == PIT_ROLES.ProcessingIncharge} onClick={calculateCbWeight} >Calculate Chipping weight</Button>
                                                    </Grid>
                                                    <Grid item xs={12} lg={12}>
                                                        <Typography variant="h5" gutterBottom>Chipped Bamboo Receipt</Typography>
                                                        <Box style={{ height: 210, width: '100%' }}>
                                                            {
                                                                rows &&
                                                                <DataGrid

                                                                    rows={rows}
                                                                    columns={col}
                                                                    pageSize={10}
                                                                // getRowId={(row) => row.bundleId}

                                                                />
                                                            }
                                                        </Box>
                                                    </Grid>

                                                </>
                                            }
                                            {heapGenerated && oldHeaps?.length > 0 &&
                                                <>
                                                    <Grid item xs={12} lg={12}>
                                                        <Typography variant="h5" gutterBottom>Heap Generated</Typography>
                                                        <Box style={{ height: 210, width: '100%' }}>
                                                            {
                                                                oldHeaps &&
                                                                <DataGrid
                                                                    rows={oldHeaps}
                                                                    columns={oldHeapsCol}
                                                                    pageSize={5}
                                                                />
                                                            }
                                                        </Box>
                                                    </Grid>
                                                </>
                                            }
                                            {heapGenerated && newHeaps.length > 0 &&
                                                <>
                                                    <Grid item xs={12} lg={12}>
                                                        <Typography variant="h5" gutterBottom>Heap Generation</Typography>
                                                        <Box style={{ height: 215, width: '100%' }}>
                                                            {
                                                                newHeaps &&
                                                                <DataGrid
                                                                    rows={newHeaps}
                                                                    columns={newHeapsCol}
                                                                    pageSize={5}
                                                                />
                                                            }
                                                        </Box>
                                                    </Grid>
                                                </>
                                            }
                                            {partialChippingDone && newHeaps.length === 0 &&
                                                <>
                                                    <Grid item xs={12} lg={12}>
                                                        <Button sx={{ minWidth: 100 }} variant="contained" >Calculate Chipping weight</Button>
                                                    </Grid>
                                                    <Grid item xs={12} lg={12}>
                                                        {/* <Typography variant="h5" gutterBottom></Typography> */}
                                                        <Box style={{ height: 220, width: '100%' }}>
                                                            {
                                                                partialChippingRow &&
                                                                <DataGrid
                                                                    rows={partialChippingRow}
                                                                    columns={partialChippingCol}
                                                                    pageSize={5}
                                                                />
                                                            }
                                                        </Box>
                                                    </Grid>
                                                </>
                                            }
                                        </>
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                {!locationUpdated && !partialChippingDone &&
                    <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                        {!heapGenerated && <Button variant="contained" sx={{ minWidth: 100 }} hidden={localStorage.getItem('role') == PIT_ROLES.ProcessingIncharge} onClick={() => onSaveButtonClick()}>Save</Button>}
                        {!heapGenerated && <Button variant="contained" sx={{ minWidth: 100, ml: 1 }} hidden={localStorage.getItem('role') == PIT_ROLES.ProcessingIncharge} onClick={() => onGenerateHeapButtonClick()} >Generate Heap </Button>}
                        {heapGenerated && <Button variant="contained" sx={{ minWidth: 100, ml: 1 }} onClick={() => onCompleteButtonClick()} > Complete Chipping</Button>}
                    </Box>

                }

                {partialChippingDone &&
                    <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                        {newHeaps.length > 0 && <Button variant="contained" sx={{ minWidth: 100 }} onClick={() => onCompleteButtonClick()} >Complete</Button>}
                        {newHeaps.length === 0 && <Button variant="contained" sx={{ minWidth: 100, ml: 1 }} hidden={localStorage.getItem('role') == PIT_ROLES.ProcessingIncharge} onClick={() => onSaveButtonClick()}>Save</Button>}
                        {newHeaps.length === 0 && <Button variant="contained" sx={{ minWidth: 100, ml: 1 }} hidden={localStorage.getItem('role') == PIT_ROLES.ProcessingIncharge} onClick={() => onGenerateHeapButtonClick()} >Generate Heap </Button>}

                    </Box>

                }
            </Container>

            <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmSave} onClose={handleConfirmClose} action="Save" />
            <ConfirmationPopover onOpen={confirmOpen2} onConfirm={onConfirmGenerateHeap} onClose={handleConfirmClose2} action="Generate Heap" />
            <ConfirmationPopover onOpen={confirmOpen3} onConfirm={onConfirmComplete} onClose={handleConfirmClose3} action="Complete Chipping" />

            <Dialog maxWidth='md' fullWidth open={logModalOpen4}>
                <DialogContent>
                    <BundleDetailsPopOver inventories={setInventories} rbInventories={rbInventories} handleLogModalClose={handleLogModalClose4} />
                </DialogContent>
            </Dialog>
            <Dialog maxWidth='xs' fullWidth open={logModalOpen}>
                <DialogContent>
                    <ConfirmPopover title={cofirmMessage} hideLink={true} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setLogModalOpen(false)}>OK</Button>
                </DialogActions>
            </Dialog>

        </>
    )
}
export default PlantChippingOperation;